import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { storeMobileNumber } from '../../../modules/auth/storage';
import { checkMobileNumber, checkMobileNumberLive } from '../../../modules/validators';
import Button from '../../common/Button';
import TextField from '../../common/TextField';

export class MobileNumberEntry extends Component {
  constructor(props) {
    super(props);

    this.handleMobileNumberChange = this.handleMobileNumberChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      mobileNumber: '',
      validationErrors: [],
      submitDisabled: true
    };
  }

  componentWillReceiveProps(nextProps) {
    const { externalErrors } = nextProps;
    if (externalErrors && externalErrors.mobileNumber) {
      this.setState({
        validationErrors: [externalErrors.mobileNumber],
      });
    } else {
      this.setState({
        validationErrors: [],
      });
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    const { mobileNumber } = this.state;
    const { submit } = this.props;
    const errors = checkMobileNumber(mobileNumber);
    const isValid = errors.length === 0;

    this.setState({
      validationErrors: (!isValid) ? [errors[0]] : []
    });

    if (isValid) {
      const number = mobileNumber.replace(/^(44|\+44)/, '0');
      storeMobileNumber(number);
      submit(number);
    }
  }

  handleMobileNumberChange(event) {
    const {
      currentTarget: {
        value
      }
    } = event;
    const errors = checkMobileNumberLive(value);
    const submitDisabled = checkMobileNumber(value).length !== 0;

    this.setState({
      mobileNumber: value,
      validationErrors: (errors.length) ? [errors[0]] : [],
      submitDisabled
    });
  }

  render() {
    const { mobileNumber, validationErrors, submitDisabled } = this.state;
    const { storageAvailable } = this.props;

    return (
      <div className="mobile-number-entry">
        <div className="container--fixed">
          <main className="mobile-number-entry__content">
            <p className="mobile-number-entry__header">
              Enter your mobile number
            </p>
            <form className="mobile-number-entry__form" onSubmit={this.handleSubmit}>
              <TextField
                name="phone"
                type="tel"
                hintText="e.g. 07788888888"
                value={mobileNumber}
                onChange={this.handleMobileNumberChange}
                className="mobile-number-entry__input"
                errors={validationErrors}
                maxLength={13}
                autoComplete
                disabled={!storageAvailable}
              />
              <Button
                className="mobile-number-entry__submit-btn"
                disabled={submitDisabled || !storageAvailable}
                onClick={this.handleSubmit}
              >
                Get verification code
              </Button>
            </form>
            <p className="mobile-number-entry__header">
              Not yet a Plus customer?
            </p>
            <p className="mobile-number-entry__paragraph">
              Sign up to Plus at your local William Hill shop to use our cash-out facility and take advantage of many other Plus benefits
            </p>
          </main>
        </div>
      </div>
    );
  }
}

MobileNumberEntry.propTypes = {
  storageAvailable: PropTypes.bool,
  externalErrors: PropTypes.object,
  submit: PropTypes.func.isRequired
};

export default withRouter(MobileNumberEntry);
